import { type CuratedItem } from "~types/types";

export const filterForStoriesWithAudioImage = (items: CuratedItem[]) =>
    items?.filter((item) => Boolean(item?.media?.audioImage));
